/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// Module to implement floating input labels in a non-React context
//
// This module automatically activates on page ready.
//
// See https://auralinna.blog/post/2018/how-to-create-material-design-like-form-text-fields/
import jQuery from 'jquery';

    // Class name for the control's wrapper container
    const WRAPPER_CLASS = 'em-input-floating';

    // Class name for the control's input element
    const INPUT_CLASS = 'em-input-floating--input';

    // Class name for the control's label element
    const LABEL_CLASS = 'em-input-floating--label';

    // Class name to set when element is focused
    const FOCUSED_CLASS = 'em-input-floating--focused';

    // Class name to set when element is a placeholder value
    const PLACEHOLDER_CLASS = 'em-input-floating--placeholder';

    // Set to true if the browser supports the :focus-within
    const SUPPORTS_FOCUS_WITHIN = (function() {
      const style = document.createElement('style');
      document.head.appendChild(style);

      try {
        style.sheet.insertRule(':focus-within {}', 0);
        return true;
      } catch (e) {
        false;
      }
      finally {
        document.head.removeChild(style);
      }

      return false;
    }());

    // Find the wrapper of element by iterating over parents until the WRAPPER_CLASS is found
    const findWrapper = function(element) {
      let wrapper = element;
      while (!!wrapper && !wrapper.classList.contains(WRAPPER_CLASS)) { wrapper = wrapper.parentNode; }
      return wrapper;
    };

    // Set the focused state on the nearest wrapper
    const setFocused = function(element, focused) {
      const wrapper = findWrapper(element);

      if (focused) {
        return (wrapper != null ? wrapper.classList.add(FOCUSED_CLASS) : undefined);
      } 
        return (wrapper != null ? wrapper.classList.remove(FOCUSED_CLASS) : undefined);
      
    };

    const setPlaceholder = function(element) {
      const wrapper = findWrapper(element);

      if (element.value === '') {
        return (wrapper != null ? wrapper.classList.add(PLACEHOLDER_CLASS) : undefined);
      } 
        return (wrapper != null ? wrapper.classList.remove(PLACEHOLDER_CLASS) : undefined);
      
    };

    // Initialize event listeners and input state
    jQuery(function($) {
      const input_selector = `.${INPUT_CLASS}`;

      $(input_selector).each(function() { return setPlaceholder(this); });

      $(document.body)
        .on('input change', input_selector, function(event) {
          setPlaceholder(this);

          if (this.name === "event_location") { return setPlaceholder(document.getElementById('event_address')); }
      });

      if (!SUPPORTS_FOCUS_WITHIN) {
        return $(document.body)
          .on('blur', input_selector, function(event) {
            return setFocused(this, false);
        }).on('focus', input_selector, function(event) {
            return setFocused(this, true);
        });
      }
    });